import { html, LitElement } from 'lit-element';

/**
 * @element response-block-multiple-choice
 * @prop {Object} response - Response
 */
export class ResponseBlockMultipleChoice extends LitElement {
  static get properties() {
    return {
      response: { type: Object, attribute: false },
      correctnessGroup: { type: String, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  openModal({ name, avatar }) {
    if (this.correctnessGroup === 'unanswered') {
      return;
    }

    const content = html`<response-modal-multiple-choice
      .response=${this.response}
    ></response-modal-multiple-choice>`;

    const title = html`
      <div class="modal-response-header">
        ${avatar}
        <span class="student-name">${name || ''}</span>
      </div>
    `;

    window.dispatchEvent(
      new CustomEvent('classroom-tool-live-open-modal', {
        detail: {
          modalContent: content,
          modalType: 'response-modal-multiple-choice',
          modalTitle: title,
        },
      })
    );
  }

  render() {
    const { sessionData, item, student } = this.response || {};
    const { name, photo, isOnline } = student || {};
    const { choices, keyMode, element } = item || {};
    const { value } = sessionData || {};
    const online = isOnline || isOnline === undefined;
    const blockClasses =
      this.correctnessGroup && this.correctnessGroup === 'unanswered'
        ? 'block'
        : 'block expandable';

    // TODO
    if (element !== 'multiple-choice') {
      return null;
    }

    const charCode = keyMode === 'numbers' ? 49 : 65;

    const valuesToRender = (choices || []).reduce((acc, choice, index) => {
      if ((value || []).indexOf(choice.value) >= 0) {
        acc.push({ index, correct: choice.correct });
      }

      return acc;
    }, []);
    let avatar;
    const opacityClass = !online ? 'offline-opacity' : '';
    const avatarClasses = `block-avatar ${opacityClass}`;

    if (photo) {
      avatar = html`<img class=${avatarClasses} src="${photo}" />`;
    } else {
      const initials = (name || '')
        .split(' ')
        .map(namePart => (namePart ? namePart[0] : ''));

      avatar = html`<div class=${avatarClasses}>${initials}</div>`;
    }

    return html` <div
      class=${online ? blockClasses : `${blockClasses} offline`}
      @click=${() => this.openModal({ name, avatar })}
    >
      ${avatar}
      <div class="block-details">
        <span class=${`student-name ${opacityClass}`}>${name || ''}</span>
        <div class="choice-value">
          <div class="block-details-important">
            ${valuesToRender.map((answer, index) => {
              const isLast = index === valuesToRender.length - 1;
              const className = answer.correct
                ? 'correct-answer'
                : 'incorrect-answer';

              return html`<span class="${className}">
                  ${String.fromCharCode(answer.index + charCode)}
                </span>
                ${isLast ? '' : ', '}`;
            })}
          </div>
        </div>
      </div>
      ${!online
        ? html`<div class="offline-label offline-opacity">offline</div>`
        : ''}
    </div>`;
  }
}

export default ResponseBlockMultipleChoice;
